/* ==========================================================================
   pdp-main.js  ·  PDP · Main product (unit M1)

   1. Add to cart without leaving the page, then open Wildroot's cart drawer.
   2. Variant pills -> the form's one name="id" input (+ a bubbling `change`, + ?variant=).
   3. The shipping row's date: the visitor's today + N days, written as "Sep. 21".

   Everything is delegated from `document`, so a section re-rendered by the theme editor
   needs no re-binding; init() only does the per-render work (dates, pill states).
   No dependencies. The sticky bar, the accordions and the gallery are other files'
   custom elements (assets/pdp.js, assets/pdp-gallery.js); this file only talks to them
   through the DOM: the ATC's `disabled`, the id input's `change`, and events.

   Events fired:  pdp:cart:added      on document   detail = Shopify's /cart/add.js answer
                  pdp:variant:change  on the root   detail = { variant, sectionId }
   ========================================================================== */
(function () {
  'use strict';

  if (window.__pdpMain) return;
  window.__pdpMain = true;

  var ROOT = '[data-pdp-main]';
  var DRAWER_ID = 'WrCartDrawer';
  var DRAWER_OPENER = '[data-wr-drawer-open="' + DRAWER_ID + '"]';
  var MONTHS = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];

  /* ------------------------------------------------------------ helpers */

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  function parse(text, fallback) {
    try {
      var value = JSON.parse(text);
      return value == null ? fallback : value;
    } catch (err) {
      return fallback;
    }
  }

  function fire(target, name, detail) {
    var event;
    try {
      event = new CustomEvent(name, { bubbles: true, detail: detail });
    } catch (err) {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(name, true, false, detail);
    }
    target.dispatchEvent(event);
  }

  /* first attribute found on the element, else on the nearest ancestor that has it */
  function attr(el, names) {
    for (var i = 0; i < names.length; i++) {
      var holder = el.hasAttribute(names[i]) ? el : closest(el, '[' + names[i] + ']');
      if (holder) return holder.getAttribute(names[i]);
    }
    return null;
  }

  function configOf(root) {
    if (!root.__pdpConfig) root.__pdpConfig = parse(root.getAttribute('data-pdp-config') || '{}', {});
    return root.__pdpConfig;
  }

  function variantsOf(root) {
    if (!root.__pdpVariants) {
      var holder = $('script[data-pdp-variants]', root);
      var list = holder ? parse(holder.textContent, []) : [];
      root.__pdpVariants = Array.isArray(list) ? list : [];
    }
    return root.__pdpVariants;
  }

  /* ------------------------------------------------------------ money */

  function delimit(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents == null) return '0';
    var parts = (cents / 100).toFixed(precision).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  function formatMoney(cents, format) {
    var pattern = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || (window.WR && window.WR.moneyFormat) || '${{amount}}';
    var match = fmt.match(pattern);
    var value;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals':
        value = delimit(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = delimit(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = delimit(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = delimit(cents, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        value = delimit(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = delimit(cents, 0, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = delimit(cents, 2, ' ', '.');
        break;
      default:
        value = delimit(cents, 2, ',', '.');
    }
    /* a money format may carry markup (<span class="money">); only its text is wanted here */
    var holder = document.createElement('div');
    holder.innerHTML = fmt.replace(pattern, value);
    return holder.textContent;
  }

  /* ------------------------------------------------------------ shipping date */

  function shipDate(days, skipWeekends) {
    var date = new Date();
    if (!skipWeekends) {
      date.setDate(date.getDate() + days);
      return date;
    }
    var left = days;
    while (left > 0) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) left--;
    }
    while (date.getDay() === 0 || date.getDay() === 6) date.setDate(date.getDate() + 1);
    return date;
  }

  function writeShipDates(scope) {
    $$('[data-pdp-ship-date]', scope).forEach(function (el) {
      var days = parseInt(attr(el, ['data-days-ahead', 'data-pdp-days-ahead', 'data-days']), 10);
      if (isNaN(days) || days < 0) days = 1;
      var skip = attr(el, ['data-skip-weekends', 'data-pdp-skip-weekends']);
      var date = shipDate(days, skip === 'true' || skip === '' || skip === '1');
      el.textContent = MONTHS[date.getMonth()] + ' ' + date.getDate();
    });
  }

  /* ------------------------------------------------------------ variants */

  function chosenOptions(root) {
    return $$('[data-pdp-option-group]', root).map(function (group) {
      var checked = $('[data-pdp-option]:checked', group);
      return checked ? checked.value : null;
    });
  }

  function matches(variant, options) {
    for (var i = 0; i < options.length; i++) {
      if (variant.options[i] !== options[i]) return false;
    }
    return true;
  }

  function findVariant(variants, options) {
    for (var i = 0; i < variants.length; i++) {
      if (matches(variants[i], options)) return variants[i];
    }
    return null;
  }

  /* a pill is struck through when no available variant has it together with the other current choices */
  function markPills(root) {
    var variants = variantsOf(root);
    var options = chosenOptions(root);
    $$('[data-pdp-option-group]', root).forEach(function (group, index) {
      $$('[data-pdp-option]', group).forEach(function (input) {
        var trial = options.slice();
        trial[index] = input.value;
        var ok = variants.some(function (variant) {
          return variant.available && matches(variant, trial);
        });
        input.classList.toggle('is-unavailable', !ok);
      });
      var label = $('[data-pdp-option-selected]', group);
      if (label && options[index] != null) label.textContent = options[index];
    });
  }

  function setButton(button, labelEl, disabled, text) {
    if (!button) return;
    button.disabled = disabled;
    /* swap the label's text only: the button also holds the spinner */
    if (labelEl && text != null && labelEl.textContent !== text) labelEl.textContent = text;
  }

  function applyVariant(root, variant) {
    var cfg = configOf(root);
    var available = !!(variant && variant.available);

    var idInput = $('[data-pdp-variant-id]', root);
    if (variant && idInput && String(idInput.value) !== String(variant.id)) {
      idInput.value = variant.id;
      /* bundle / subscription widgets and the gallery watch this input */
      var change;
      try {
        change = new Event('change', { bubbles: true });
      } catch (err) {
        change = document.createEvent('Event');
        change.initEvent('change', true, false);
      }
      idInput.dispatchEvent(change);
    }

    if (variant && window.history && history.replaceState && !(window.Shopify && window.Shopify.designMode)) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(history.state, '', url.toString());
      } catch (err) {
        /* an odd URL is no reason to stop */
      }
    }

    $$('[data-pdp-atc]', root).forEach(function (atc) {
      var text = available
        ? atc.getAttribute('data-label') || cfg.atcLabel
        : variant
          ? atc.getAttribute('data-sold-out-label') || cfg.soldOutLabel
          : atc.getAttribute('data-unavailable-label') || cfg.unavailableLabel;
      setButton(atc, $('[data-pdp-atc-label]', atc), !available, text);
    });

    /* the bar only mirrors the ATC when its button adds to cart; in scroll mode it always scrolls */
    var stickyBtn = $('[data-pdp-sticky-btn]', root);
    if (stickyBtn && cfg.stickyAction === 'add') {
      var stickyLabel = $('[data-pdp-sticky-label]', stickyBtn);
      var normal = stickyLabel ? stickyLabel.getAttribute('data-label') : null;
      setButton(stickyBtn, stickyLabel, !available, available ? normal : variant ? cfg.soldOutLabel : cfg.unavailableLabel);
    }

    if (variant) {
      $$('[data-pdp-price]', root).forEach(function (el) {
        el.textContent = formatMoney(variant.price, cfg.moneyFormat);
      });
      $$('[data-pdp-compare-price]', root).forEach(function (el) {
        var was = variant.compare_at_price > variant.price;
        el.hidden = !was;
        if (was) el.textContent = formatMoney(variant.compare_at_price, cfg.moneyFormat);
      });
    }

    markPills(root);
    fire(root, 'pdp:variant:change', { variant: variant, sectionId: cfg.sectionId });
  }

  function onChange(event) {
    var input = event.target;
    if (!input || !input.hasAttribute || !input.hasAttribute('data-pdp-option')) return;
    var root = closest(input, ROOT);
    if (!root) return;
    applyVariant(root, findVariant(variantsOf(root), chosenOptions(root)));
  }

  /* ------------------------------------------------------------ add to cart */

  function setLoading(root, form, on) {
    form.__pdpBusy = on;
    $$('[data-pdp-atc]', form).forEach(function (atc) {
      /* neither `disabled` nor aria-disabled: the sticky bar reads both as "sold out", and pdp.css dims them.
         .is-loading already takes the pointer away, and __pdpBusy swallows a second submit. */
      atc.classList.toggle('is-loading', on);
      if (on) atc.setAttribute('aria-busy', 'true');
      else atc.removeAttribute('aria-busy');
    });
    var stickyBtn = $('[data-pdp-sticky-btn]', root);
    if (stickyBtn && (configOf(root).stickyAction === 'add' || !on)) stickyBtn.classList.toggle('is-loading', on);
  }

  function showError(form, message) {
    var el = $('.pdp-main__error', form);
    if (!el) {
      if (!message) return;
      var atc = $('[data-pdp-atc]', form) || $('[name="add"]', form);
      if (!atc) return;
      el = document.createElement('div');
      el.className = 'pdp-main__error';
      el.setAttribute('role', 'alert');
      atc.insertAdjacentElement('afterend', el);
    }
    el.textContent = message || '';
    if (message) el.removeAttribute('hidden');
  }

  function errorText(json) {
    if (!json) return '';
    var text = json.description || json.message || '';
    if (text && typeof text === 'object') {
      text = Object.keys(text)
        .map(function (key) {
          return [].concat(text[key]).join(' ');
        })
        .join(' ');
    }
    return String(text);
  }

  /* theme.js bound the drawer's +/- buttons once, at load; markup swapped in later gets this instead
     (attached at the first swap, so no button ever has both) */
  function bindDrawerQty(drawer) {
    if (drawer.__pdpQty) return;
    drawer.__pdpQty = true;
    drawer.addEventListener('click', function (event) {
      var button = closest(event.target, '[data-wr-qty-step]');
      if (!button || !drawer.contains(button)) return;
      var input = $('input', closest(button, '.wr-qty'));
      if (!input) return;
      var step = parseInt(button.getAttribute('data-wr-qty-step'), 10) || 0;
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) + step);
      var form = closest(button, 'form');
      if (form) HTMLFormElement.prototype.submit.call(form);
    });
  }

  function syncCartCount(freshDoc) {
    var freshOpener = freshDoc.querySelector(DRAWER_OPENER);
    if (!freshOpener) return;
    var freshCount = freshOpener.querySelector('.wr-cart-count');
    $$(DRAWER_OPENER).forEach(function (opener) {
      var count = $('.wr-cart-count', opener);
      if (!freshCount) {
        if (count && count.parentNode) count.parentNode.removeChild(count);
        return;
      }
      if (!count) {
        count = document.createElement('span');
        count.className = 'wr-cart-count';
        opener.appendChild(count);
      }
      count.textContent = freshCount.textContent;
    });
  }

  /* The drawer is a snippet in the layout, not a section, so the Section Rendering API cannot
     return it: fetch any storefront page, lift the drawer out, and let theme.js open it. */
  function openCart(cfg) {
    var opener = $(DRAWER_OPENER);
    var drawer = document.getElementById(DRAWER_ID);
    if (cfg.cartType !== 'drawer' || !opener || !drawer) {
      window.location.href = cfg.cartUrl || '/cart';
      return Promise.resolve();
    }
    return fetch(window.location.pathname, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'text/html' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart drawer: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html');
        var freshDrawer = fresh.getElementById(DRAWER_ID);
        if (!freshDrawer) throw new Error('cart drawer: not in the page');
        drawer.innerHTML = freshDrawer.innerHTML;
        bindDrawerQty(drawer);
        syncCartCount(fresh);
        opener.click(); /* theme.js owns the overlay, the scroll lock and the focus */
      });
  }

  function addToCart(root, form, cfg) {
    setLoading(root, form, true);
    showError(form, '');

    fetch(cfg.cartAddUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: new FormData(form) /* id, quantity, selling_plan, properties[...] and whatever an app put in the form */
    })
      .then(function (response) {
        return response.json().then(function (json) {
          return { ok: response.ok, json: json };
        });
      })
      .then(
        function (result) {
          if (!result.ok || (result.json && result.json.status >= 400)) {
            setLoading(root, form, false);
            showError(form, errorText(result.json) || cfg.unavailableLabel || '');
            return;
          }
          /* the line is in the cart from here on: nothing below may fall back to a second, native add */
          try {
            fire(document, 'pdp:cart:added', result.json);
          } catch (err) {
            /* a listener's error is not ours */
          }
          return openCart(cfg)
            .catch(function () {
              window.location.href = cfg.cartUrl || '/cart';
            })
            .then(function () {
              setLoading(root, form, false);
            });
        },
        function () {
          /* offline, blocked, or not JSON: the plain POST still works */
          setLoading(root, form, false);
          HTMLFormElement.prototype.submit.call(form);
        }
      );
  }

  /* On `document`, bubble phase: every listener an app put on the button, the form or an
     ancestor has run by now. If one of them took the submit over (a bundle app going
     straight to checkout, say), it is theirs. */
  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-pdp-form')) return;
    if (event.defaultPrevented) return;
    var root = closest(form, ROOT);
    if (!root || !window.fetch || !window.FormData || !window.DOMParser || !window.Promise) return;
    var cfg = configOf(root);
    if (!cfg.cartAddUrl) return;
    event.preventDefault();
    if (form.__pdpBusy) return;
    addToCart(root, form, cfg);
  }

  /* ------------------------------------------------------------ life cycle */

  /* pdp.css draws the loading state as an <svg><circle> inside .pdp-btn__spinner; a button that
     ships the holder empty gets the drawing here (an empty holder only: nothing is replaced) */
  function fillSpinners(root) {
    $$('.pdp-btn__spinner', root).forEach(function (holder) {
      if (holder.firstElementChild) return;
      holder.innerHTML =
        '<svg viewBox="0 0 66 66" width="20" height="20" fill="none" focusable="false" aria-hidden="true">' +
        '<circle cx="33" cy="33" r="30" stroke="currentColor" stroke-width="6" stroke-linecap="round"></circle></svg>';
    });
  }

  function init(root) {
    if (!root) return;
    /* a re-render in the editor brings a new element; drop anything cached on a reused one */
    root.__pdpConfig = null;
    root.__pdpVariants = null;
    try {
      fillSpinners(root);
    } catch (err) {
      /* the label still goes transparent while loading */
    }
    try {
      writeShipDates(root);
    } catch (err) {
      /* the server's date stays */
    }
    try {
      if ($('[data-pdp-option]', root)) markPills(root);
    } catch (err) {
      /* pills stay as rendered */
    }
  }

  function initAll() {
    $$(ROOT).forEach(init);
  }

  document.addEventListener('submit', onSubmit, false);
  document.addEventListener('change', onChange, false);

  document.addEventListener('shopify:section:load', function (event) {
    init($(ROOT, event.target));
  });

  /* back/forward cache: never come back to a button that is still spinning */
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    $$(ROOT).forEach(function (root) {
      var form = $('form[data-pdp-form]', root);
      if (form) setLoading(root, form, false);
      try {
        writeShipDates(root);
      } catch (err) {
        /* keep what is there */
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
